import React from 'react';
import classNames from 'classnames';

import type { PlanHighlight } from 'js/src/client';
import Button, { BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';
import ContentPlaceholder from 'js/src/components/common/ui/ContentPlaceholder';

const PricingPlanHighlights = React.memo(function PricingPlanHighlights({
    highlights,
    showAndMore,
    andMoreClicked,
    className,
}: {
    highlights?: PlanHighlight[];
    showAndMore: boolean;
    andMoreClicked: (e: React.MouseEvent) => void;
    className?: string;
}) {
    let highlight_nodes;

    if (!highlights) {
        // Skeleton loading state
        highlight_nodes = [
            <div key="skeleton-0" className="my-l5-16">
                <ContentPlaceholder styleProps={{ width: '150px', height: '20px' }} />
            </div>,
            <li key="skeleton-1" className={classNames('my-l5-16', 'd-flex align-items-center')}>
                <i className="material-symbols-outlined icon-l5 text-success p-l5-4">check</i>
                <ContentPlaceholder styleProps={{ width: '120px', height: '16px' }} />
            </li>,
            <li key="skeleton-2" className={classNames('my-l5-16', 'd-flex align-items-center')}>
                <i className="material-symbols-outlined icon-l5 text-success p-l5-4">check</i>
                <ContentPlaceholder styleProps={{ width: '140px', height: '16px' }} />
            </li>,
            <li key="skeleton-3" className={classNames('my-l5-16', 'd-flex align-items-center')}>
                <i className="material-symbols-outlined icon-l5 text-success p-l5-4">check</i>
                <ContentPlaceholder styleProps={{ width: '100px', height: '16px' }} />
            </li>,
        ];
    } else {
        // Normal rendering with highlights data
        highlight_nodes = highlights.map((highlight, index) => {
            const className = 'my-l5-16';
            if (index === 0) {
                return (
                    <div key={index} className={className}>
                        <b>{highlight.text1}</b>
                    </div>
                );
            } else {
                return (
                    <li key={index} className={classNames(className, 'd-flex align-items-center')}>
                        <i className="material-symbols-outlined icon-l5 text-success p-l5-4">
                            check
                        </i>
                        <span>{highlight.text1}</span>
                    </li>
                );
            }
        });
    }
    return (
        <div className="pricing-plan-highlights">
            <ul className={classNames('pricing-plan-highlights list-unstyled', className)}>
                {highlight_nodes}
            </ul>
            {showAndMore && highlights && (
                <div className="row">
                    <div className="col-md-12">
                        <Button
                            variant={BUTTON_VARIANTS.LINK}
                            text="and more..."
                            onClick={andMoreClicked}
                        />
                    </div>
                </div>
            )}
        </div>
    );
});

export default PricingPlanHighlights;
